import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';

export default function DatePickerInput({
	label,
	value,
	name,
	onChange,
	maxDate,
	maxDateMessage,
	minDate,
	minDateMessage,
	className,
	disableFuture = true,
}) {
	const minMaxProps = {};
	if (maxDate) {
		minMaxProps.maxDate = maxDate;
		minMaxProps.maxDateMessage = maxDateMessage || '';
	} else {
		delete minMaxProps.maxDate;
		delete minMaxProps.maxDateMessage;
	}

	if (minDate) {
		minMaxProps.minDate = minDate;
		minMaxProps.minDateMessage = minDateMessage || '';
	} else {
		delete minMaxProps.minDate;
		delete minMaxProps.minDateMessage;
	}

	const dateValue = moment(value);

	return (
		<DatePicker
			label={label}
			value={dateValue}
			id={`date-picker-inline-${name}`}
			disableFuture={disableFuture}
			name={name}
			onChange={onChange}
			slotProps={{
				className,
				inputAdorment: { position: 'start' },
				textField: {
					InputProps: {
						sx: className,
					},
				},
			}}
		/>
	);
}
